import * as React from 'react';
import { useSelector } from 'react-redux';

import { selectIsNewbuildingConsultTopBannerAvailable } from '../../../selectors/newbuildingConsultBanner';
import { NewbuildingConsultTopBannerContainer } from '../../../serp/components/NewbuildingConsultTopBanner';

export function BannerContainer() {
  const newbuildingConsultTopBannerAvailable = useSelector(selectIsNewbuildingConsultTopBannerAvailable);

  if (newbuildingConsultTopBannerAvailable) {
    return <NewbuildingConsultTopBannerContainer />;
  }

  return null;
}
